import React from 'react';
import { func } from 'prop-types';

import IconButton from '@material-ui/core/IconButton';
import Popover from '@material-ui/core/Popover';

import IconMoreHorz from '../../shared/icons/IconMoreHorz';

const ContextMenuReport = ({ handleViewReports }) => {
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleAction = () => {
    handleClose();
    handleViewReports();
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  return (
    <div className="de--campaign--context-menu">
      <IconButton
        aria-describedby={id}
        className="ct--col__actions--button"
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleClick}
      >
        <IconMoreHorz />
      </IconButton>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        className="de--campaign--context-popover de--campaign--context-popover--small"
      >
        <div className="de--campaign--context-root">
          <button
            type="button"
            onClick={e => handleAction(e)}
            className="de--campaign--context-item"
            data-test="label"
          >
            <span>View Reports</span>
          </button>
        </div>
      </Popover>
    </div>
  );
};

ContextMenuReport.propTypes = {
  handleViewReports: func,
};

export default ContextMenuReport;
